import { EditCoverGalleryTabConfig } from "src/screens/(internal)/EditCoverGalleryModal/types";
import { enumNever } from "src/shared/helpers/generalHelpers";

const getTabName = (config: EditCoverGalleryTabConfig) => {
	const { variant } = config;
	switch (variant) {
		case "GatheringPhotos":
			return "Album photos";
		case "Posters":
			return "Posters";
		case "Upload":
			return "Upload";
		case "AIGeneration":
			return "Generate";
		default:
			return enumNever(variant);
	}
};
export default getTabName;
